// store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from './reducers';
 
// export default store; 
export default configureStore({
  reducer: rootReducer,
});